import { useRef } from "react";
import { Rate } from "antd";
import { UiButton, UiDrawer, UiProfileModel } from "../../components";
import UiWarningRating from "../uiWarning";
import dayjs from "dayjs";
import { downloadFileByUrl, formatPhoneNumber, playMediaByRef, formatAmount } from "../../utils/appUtils";
import { downloadReport, userIcon } from "../../assets/images";
const ConsultationView = ({
    consultation,
    consultationBooleans,
    consultationIdData,
    handleConsultationClose,
    onRefund,
    isRefundDisabled = false
}) => {
    const videoElementRef = useRef(null);
    const lawyerProfileData = consultationIdData?.consultationInfo?.lawyerResponse;
    const customerProfileData = consultationIdData?.consultationInfo?.customerResponse;
    const complaintData = consultationIdData?.consultationInfo?.complaintDto;
    const consultationAmountDetails = consultationIdData?.consultationInfo?.consultationPaymentDetails;
    const recordDetail = consultationAmountDetails?.recordDetail || consultationIdData?.consultationInfo?.recordDetail || {};
    const recordingUrl = recordDetail?.recordingUrl || "";
    const hasRecording = Boolean(recordDetail?.record) || Boolean(recordingUrl);
    const recordWithoutGSt = recordDetail?.recordAmountWithoutGst || 0;
    const recordeGst = recordDetail?.recordGstAmount || 0;
    const recordTotalAmount = recordDetail?.totalRecordAmount || 0;
    const addOnGstAmountSum = consultationIdData?.consultationInfo?.consultationPaymentDetails?.addOnList?.reduce((sum, detail) => sum + (detail?.gstAmount || 0), 0) || 0;
    const addOnWithoutGstSum = consultationIdData?.consultationInfo?.consultationPaymentDetails?.addOnList?.reduce((sum, detail) => sum + (detail?.amountWithOutGst || 0), 0) || 0;
    const addOnTotalAmount = consultationIdData?.consultationInfo?.consultationPaymentDetails?.addOnList?.reduce((sum, detail) => sum + (detail?.totalAmount || 0), 0) || 0;
    const baseFeeDetails = consultationAmountDetails?.consultationFeesDetails;
    const consultationWithoutGst = baseFeeDetails ? (baseFeeDetails?.consultationFeeWithoutGst || 0) : (consultationAmountDetails?.consultationAmountWithOutGst || 0);
    const consultationGstAmount = baseFeeDetails ? (baseFeeDetails?.consultationFeeGst || 0) : (consultationAmountDetails?.consultationGstAmount || 0);
    const consultationTotalAmount = baseFeeDetails ? (baseFeeDetails?.consultationTotalFee || 0) : (consultationAmountDetails?.totalConsultationAmount || 0);

    const extendList = Array.isArray(consultationIdData?.consultationInfo?.extendConsultionDetailsList)
        ? consultationIdData.consultationInfo.extendConsultionDetailsList
        : consultationIdData?.consultationInfo?.extendConsultionDetailsList
            ? [consultationIdData.consultationInfo.extendConsultionDetailsList]
            : [];
    const extendWithoutGstSum = extendList.reduce((sum, detail) => sum + (Number(detail?.amountWithoutGst) || 0), 0);
    const extendGstAmountSum = extendList.reduce((sum, detail) => sum + (Number(detail?.gstAmount) || 0), 0);
    const extendTotalAmountSum = extendList.reduce((sum, detail) => sum + (Number(detail?.totalAmount) || 0), 0);

    const gstRate = consultationWithoutGst > 0 ? (consultationGstAmount / consultationWithoutGst) : 0.18;

    const couponAmount = Number(consultationAmountDetails?.couponAmount) || 0;
    const couponPercentage = Number(consultationAmountDetails?.couponPercentage) || 0;
    const couponGst = couponAmount * gstRate;
    const couponTotal = couponAmount + couponGst;

    const discountAmount = Number(consultationAmountDetails?.discountAmount) || 0;
    const discountPercentage = Number(consultationAmountDetails?.discountPercentage) || 0;
    const discountGst = discountAmount * gstRate;
    const discountTotal = discountAmount + discountGst;

    const totalWithoutGSt = consultationAmountDetails?.consultationAmountWithOutGst || 0;
    const totalGstAmount = consultationAmountDetails?.consultationGstAmount || 0;
    const totalAmounts = consultationAmountDetails?.totalConsultationAmount || 0;

    const handlePlayRecord = () => {
        playMediaByRef(videoElementRef);
    };

    const handleDownloadRecord = () => {
        downloadFileByUrl(recordingUrl, "consultation-recording.mp4");
    };
    const isAlreadyRefunded = Boolean(
        consultationIdData?.consultationInfo?.isRefunded ||
        consultationIdData?.consultationInfo?.refundStatus === "REFUNDED" ||
        consultationIdData?.consultationInfo?.refundStatus === "SUCCESS" ||
        Number(consultationIdData?.consultationInfo?.refundAmount || 0) > 0 ||
        consultationAmountDetails?.refundId ||
        consultationAmountDetails?.isRefunded ||
        consultationAmountDetails?.refundStatus === "REFUNDED" ||
        consultationAmountDetails?.refundStatus === "SUCCESS" ||
        Number(consultationAmountDetails?.refundAmount || 0) > 0
    );

    return <>
        <UiDrawer
            open={consultationBooleans?.isconsultationDrawerOpen}
            title={
                consultation?.activeTab === "COMPLETED" ? "Completed Cons." :
                    consultation?.activeTab === "CANCELLED" ? "Cancelled Cons." :
                        consultation?.activeTab === "AUTO_CANCELLED" ? "Auto Cancelled Cons." :
                            consultation?.activeTab === "LOW_RATING" ? "Low Rating Cons." : "UpComing Cons."
            }
            width={600}
            onClose={handleConsultationClose}
            footer={<>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    {onRefund && consultation?.activeTab !== "CANCELLED" && (
                        <UiButton
                            type="primary"
                            disabled={isRefundDisabled}
                            onClick={onRefund}
                        >
                            {isAlreadyRefunded ? "Refunded" : "Refund"}
                        </UiButton>
                    )}
                    <UiButton onClick={handleConsultationClose}>Close</UiButton>
                </div>
            </>}
        >
            <div className="lawyer-information" style={{ margin: "10px 0px" }}>
                <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                    <div className="flexible">
                        {
                            !consultationIdData?.lawyerProfile || consultationIdData?.lawyerProfile?.includes("null") || consultationIdData?.lawyerProfile?.includes("undefined") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> : <UiProfileModel imageUrl={consultationIdData?.lawyerProfile} />
                        }
                        <div>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.salutation} {lawyerProfileData?.firstName} {lawyerProfileData?.middleName} {lawyerProfileData?.lastName}</h3>
                            {<div style={{ padding: "5px 10px" }}>
                                <UiWarningRating count={lawyerProfileData?.warningCountAfterActive} />
                            </div>}
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Advocate ID</small>
                            <h3 className="lawerInfo-detail">{lawyerProfileData?.lawyerNo}</h3>
                        </div>
                    </div>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="lawerInfo-detail">{formatPhoneNumber(lawyerProfileData?.mobileNumber) || "-"}</h3>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h3 className="lawerInfo-detail">{lawyerProfileData?.email || "-"}</h3>
                    </div>
                </div>
            </div>
            <div className="lawyer-information">
                <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                    <div className="flexible">
                        {
                            !consultationIdData?.customerProfile || consultationIdData?.customerProfile?.includes("null") || consultationIdData?.customerProfile?.includes("undefined") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> : <UiProfileModel imageUrl={consultationIdData?.customerProfile} />
                        }
                        <div>
                            <h3 className="lawerInfo-detail">{customerProfileData?.salutation} {customerProfileData?.firstName} {customerProfileData?.middleName} {customerProfileData?.lastName}</h3>
                            {<div style={{ padding: "5px 10px" }}>
                                <UiWarningRating count={customerProfileData?.warningCountAfterActive} />
                            </div>}
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Customer ID</small>
                            <h3 className="lawerInfo-detail">{customerProfileData?.customerNo || "-"}</h3>
                        </div>
                    </div>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="lawerInfo-detail">{formatPhoneNumber(customerProfileData?.mobileNumber) || "-"}</h3>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h3 className="lawerInfo-detail">{customerProfileData?.email || "-"}</h3>
                    </div>
                </div>
            </div>
            <div className="lawyer-details">
                <div>
                    <div className="flexible" style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                        <h3 className="lawyerInfo-heading" >Cons. Details</h3>
                        {
                            hasRecording && <div className="success-status" style={{ width: "100px" }}>
                                <p>Recorded</p>
                            </div>
                        }
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Cons. Date</small>
                            <h3 className="lawerInfo-detail">{consultationIdData?.consultationInfo?.consultationDate ? dayjs(consultationIdData?.consultationInfo?.consultationDate).format("DD-MM-YYYY") : ""}</h3>
                        </div>
                        <div>
                            <small className="information-header">Cons. ID</small>
                            <h3 className="lawerInfo-detail">{consultationIdData?.consultationInfo?.consultationNo || "-"}</h3>
                        </div>
                        <div>
                            <small className="information-header">Start Time</small>
                            <h3 className="lawerInfo-detail">{consultationIdData?.consultationInfo?.consultationStartTime ? dayjs(consultationIdData?.consultationInfo?.consultationStartTime).format("hh:mm A") : ""}</h3>
                        </div>
                        <div>
                            <small className="information-header">End Time</small>
                            <h3 className="lawerInfo-detail">{consultationIdData?.consultationInfo?.consultationEndTime ? dayjs(consultationIdData?.consultationInfo?.consultationEndTime).format("hh:mm A") : ""}</h3>
                        </div>
                    </div>
                </div>
                {
                    consultationAmountDetails?.addOnList ? <div style={{ padding: "10px" }}>
                        <h3 className="lawyerInfo-heading" style={{ padding: "10px 0px" }}>Add On Details</h3>
                        <div>
                            <table className="addon-table">
                                <thead style={{ textAlign: "left" }}>
                                    <tr>
                                        <th>Members</th>
                                        <th>Fees</th>
                                    </tr>
                                </thead>
                                {
                                    consultationAmountDetails?.addOnList?.map((detail) => {
                                        return <tbody style={{ textAlign: "left" }}>
                                            <tr>
                                                <td>{detail?.addOn}</td>
                                                <td>&#8377; {formatAmount(detail?.totalAmount)}</td>
                                            </tr>
                                        </tbody>
                                    })
                                }
                            </table>
                        </div>
                    </div> : ""
                }
                {
                    consultationAmountDetails && Object.keys(consultationAmountDetails)?.length > 0 &&
                    <div style={{ padding: "10px" }}>
                        <h3 className="lawyerInfo-heading" style={{ padding: "10px 0px" }}>Payment details</h3>
                        <div>
                            <table className="addon-table">
                                <thead style={{ textAlign: "left" }}>
                                    <th>Members</th>
                                    <th>Fees without GST</th>
                                    <th>    GST</th>
                                    <th>Total Fees</th>
                                </thead>
                                <tbody style={{ textAlign: "left" }}>
                                    <tr>
                                        <td>Consultation</td>
                                        <td>&#8377; {formatAmount(consultationWithoutGst)}</td>
                                        <td>&#8377; {formatAmount(consultationGstAmount)}</td>
                                        <td>&#8377; {formatAmount(consultationTotalAmount)}</td>
                                    </tr>
                                    <tr>
                                        <td>Add-on</td>
                                        <td>&#8377; {formatAmount(addOnWithoutGstSum)}</td>
                                        <td>&#8377; {formatAmount(addOnGstAmountSum)}</td>
                                        <td>&#8377; {formatAmount(addOnTotalAmount)}</td>
                                    </tr>
                                    {extendTotalAmountSum > 0 && (
                                        <tr>
                                            <td>Extend Consultation</td>
                                            <td>&#8377; {formatAmount(extendWithoutGstSum)}</td>
                                            <td>&#8377; {formatAmount(extendGstAmountSum)}</td>
                                            <td>&#8377; {formatAmount(extendTotalAmountSum)}</td>
                                        </tr>
                                    )}
                                    <tr>
                                        <td>Record</td>
                                        <td>&#8377; {formatAmount(recordWithoutGSt)}</td>
                                        <td>&#8377; {formatAmount(recordeGst)}</td>
                                        <td>&#8377; {formatAmount(recordTotalAmount)}</td>
                                    </tr>
                                    {couponAmount > 0 && (
                                        <tr>
                                            <td>Coupon{couponPercentage > 0 ? ` (${couponPercentage}%)` : ""}</td>
                                            <td>- &#8377; {formatAmount(couponAmount)}</td>
                                            <td>- &#8377; {formatAmount(couponGst)}</td>
                                            <td>- &#8377; {formatAmount(couponTotal)}</td>
                                        </tr>
                                    )}
                                    {discountAmount > 0 && (
                                        <tr>
                                            <td>Discount{discountPercentage > 0 ? ` (${discountPercentage}%)` : ""}</td>
                                            <td>- &#8377; {formatAmount(discountAmount)}</td>
                                            <td>- &#8377; {formatAmount(discountGst)}</td>
                                            <td>- &#8377; {formatAmount(discountTotal)}</td>
                                        </tr>
                                    )}
                                    <tr style={{ fontWeight: 700 }}>
                                        <td>Total</td>
                                        <td>&#8377; {formatAmount(totalWithoutGSt)}</td>
                                        <td>&#8377; {formatAmount(totalGstAmount)}</td>
                                        <td>&#8377; {formatAmount(totalAmounts)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                {
                    consultation?.activeTab === "COMPLETED" && <div>
                        <div style={{ padding: "10px 0px" }}>
                            <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                                <h3 className="lawerInfo-detail">Complaint</h3>
                            </div>
                            <div className="flexible">
                                <div>
                                    <small className="information-header">Complaint Raised</small>
                                    <h3 className="lawerInfo-detail">{complaintData?.raisedByName || "-"}</h3>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                                <h3 className="lawyerInfo-heading">Feedback</h3>
                            </div>
                            <div>
                                <p>{consultationIdData?.consultationInfo?.feedback?.feedback || "-"}</p>
                            </div>
                        </div>
                    </div>
                }
                {
                    (consultation?.activeTab === "CANCELLED" || consultation?.activeTab === "AUTO_CANCELLED") && <div>
                        <div>
                            <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                                <h3 className="lawyerInfo-heading">Reason For Cancellation</h3>
                            </div>
                            <div>
                                <p>{consultationIdData?.consultationInfo?.cancelDetails?.reason || "-"}</p>
                            </div>
                        </div>
                    </div>
                }
                {
                    consultation?.activeTab === "LOW_RATING" && <div>
                        <div style={{ padding: "10px 0px" }}>
                            <div style={{ borderBottom: "1px solid #005D60", padding: "10px 0px" }}>
                                <h3 className="lawyerInfo-heading">Ratings</h3>
                            </div>
                            <div style={{ padding: "10px 0px" }}>
                                <Rate disabled allowHalf defaultValue={consultationIdData?.consultationInfo?.feedback?.rating || 0} style={{ fontSize: 20 }} />
                            </div>
                        </div>
                        <div>
                            <div style={{ borderBottom: "1px solid #005D60", padding: "10px 0px" }}>
                                <h3 className="lawyerInfo-heading">Reason</h3>
                            </div>
                            <div style={{ padding: "10px 0px" }}>
                                <p>{consultationIdData?.consultationInfo?.feedback?.ratingReason || "-"}</p>
                            </div>
                        </div>
                    </div>
                }
                {
                    hasRecording && recordingUrl ? <div style={{ padding: "10px" }}>
                        <div
                            style={{
                                backgroundColor: "#d9d9d9",
                                minHeight: "200px",
                                borderRadius: "8px",
                                marginBottom: "16px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "10px"
                            }}
                        >
                            <video
                                ref={videoElementRef}
                                src={recordingUrl}
                                controls
                                preload="metadata"
                                style={{ width: "100%", maxHeight: "320px", borderRadius: "8px", backgroundColor: "#000" }}
                            />
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                            <UiButton type="default" style={{ backgroundColor: "#005D6033", color: "#005D60" }} onClick={handlePlayRecord}>Play Record</UiButton>
                            <UiButton style={{ backgroundColor: "#CCBA78", color: "white" }} onClick={handleDownloadRecord}><img src={downloadReport} alt="" />Download Record</UiButton>
                        </div>
                    </div> : ""
                }
            </div>
        </UiDrawer>
    </>
};
export default ConsultationView